import { graphql, useStaticQuery } from 'gatsby'

export const usePlaceholderImage = () => {
  return useStaticQuery(
    graphql`
      query placeholderImage {
        image: file(relativePath: { eq: "motat_fallback.jpg" }) {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
    `,
  )
}
